export const filterAccessibleTranscripts = (currentTranscripts, newTranscripts) => {
    const updatedTranscripts = [];
    const transcriptMapping = {};
    currentTranscripts.forEach((transcript) => {
        if (!(transcript.roomId in transcriptMapping)) {
            transcriptMapping[transcript.roomId] = true;
            updatedTranscripts.push(transcript);
        }
    });
    newTranscripts.forEach((transcript) => {
        if (!(transcript.roomId in transcriptMapping)) {
            transcriptMapping[transcript.roomId] = true;
            updatedTranscripts.push(transcript);
        }
    });
    const filteredTranscripts = updatedTranscripts.filter((transcript) => {
        return transcript.hasTranscripts && transcript.isAllowedAccess && !transcript.deleted;
    });
    return filteredTranscripts;
};
export const retrieveLastReadTranscript = (newTranscripts) => newTranscripts[newTranscripts.length - 1];
export const filterDeletedTranscript = (currentTranscripts, deletedTranscript) => {
    const filteredTranscripts = currentTranscripts.filter((transcript) => transcript.roomId !== deletedTranscript.roomId);
    return filteredTranscripts;
};
export const filterDeletedManyTranscripts = (currentTranscripts, deletedTranscriptIds) => currentTranscripts.filter((transcript) => !deletedTranscriptIds.includes(transcript.roomId));
export const updateTranscripts = (currentTranscripts, updatedTranscript) => {
    const updatedTranscripts = [...currentTranscripts];
    for (let i = 0; i < updatedTranscripts.length; i += 1) {
        if (updatedTranscripts[i].roomId === updatedTranscript.roomId) {
            updatedTranscripts[i] = Object.assign({}, updatedTranscript);
            break;
        }
    }
    return updatedTranscripts;
};
